import { useBusinessContext } from '@root/context'
import { useQuery } from '@tanstack/react-query'
import { fetchDocument } from '../documents'

export const useDocument = ({ documentId }: { documentId: number }, options = {}) => {
  const { slug } = useBusinessContext()
  return useQuery({
    queryKey: [slug, 'documents', documentId],
    queryFn: () => fetchDocument({ documentId, slug }),
    enabled: !!slug && !!documentId,
    ...options
  })
}
